// extracted by mini-css-extract-plugin
export default {"textLinearGradient":"style_textLinearGradient__ZXk8F","animateText":"style_animateText__GWLDa"};